import { createdATFilter, getVisibleFilter } from 'modules/common/constants/filters/common.filters';
import { addressFilters } from 'lib/dfl-address-filter/filters';
import { getProviderLogisticFilter } from 'modules/common/constants/filters';

const visibleFilter = getVisibleFilter('visible');

const carrierAddressFilter = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'address.country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'address.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'address.city',
});

export const carrierFilters = [
  getProviderLogisticFilter('logistic._id'),
  ...carrierAddressFilter,
  visibleFilter,
  createdATFilter,
];
